import * as React from 'react';
import { StyledCircularProgressContainer, StyledCircularProgressLabel, StyledCircularProgressColor } from './Style';
import { CircularProgress } from '@material-ui/core';
/**
 * A Circular Progress Loader that has vertical and horizontal centering
 * @param {number | string | undefined} props.size The size of the circle. If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit, e.g '3rem'.
 * @param { 'determinate'| 'indeterminate'| 'static'} props.variant The variant to use. Use indeterminate when there is no progress value.
 * @param {number} props.value The value of the progress indicator for the determinate and static variants. Value between 0 and 100.
 ** @param {boolean} props.hasPercentageLabel The CSS of circle and lable as required. If using a boolean, you need to provide the conditional CSS, e.g color(true)? 'red' : 'green'.
 */
export const ProgressCircle = ({ size, variant, value, label = '', hasPercentageLabel }) => {
    return (React.createElement(StyledCircularProgressContainer, { container: true, alignItems: "center", justify: "center" },
        React.createElement(StyledCircularProgressColor, { hasPercentageLabel: hasPercentageLabel },
            React.createElement(CircularProgress, { color: 'inherit', size: size, variant: variant, value: value })),
        label && (React.createElement(StyledCircularProgressLabel, { hasPercentageLabel: hasPercentageLabel }, label))));
};
ProgressCircle.defaultProps = {
    size: 50
};
//# sourceMappingURL=ProgressCircle.js.map